// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dashboard {
  text-align: center;
  background-color:#FFFFFF;
}

h1 {
  margin-top:0px;
  margin-bottom:20px;
  color: #343434;
  font-size: 35px;
}

p {
  font-size: 16px;
}

.App-header, .App-body{
  min-height: 100vh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
}

.App-link {
  color: #61dafb;
}

.graphs, .leaflet-container{
  border-radius: 25px;
  width: 100%;
  height: 350px;
  border: 4px solid #000000;
  margin: 0 auto;
}

.leaflet-container{
  height:340px;
}

.map-container{
  width: 92%;
  position: relative;
  margin: 0 auto;
}

#map-dark-theme-btn{
  position: absolute;
  top: 14px;
  right: 16px;
  z-index: 401;
}

#map-show-all-nodes-btn{
  position: absolute;
  top: 14px;
  right: 65px;
  z-index: 401;
}

#copy-link-btn{
  position: absolute;
  top: 60px;
  right: 16px;
  z-index: 401;
}

#scoll-to-top-btn{
  position: fixed; 
  bottom: 20px; 
  right: 20px;  
  display: flex; 
  justify-content: center; 
  height:55px;
  width:55px;
  border: 3px solid #000000;
  z-index: 405;
}

#map-popup{
  z-index: 402 !important;
}

.bi-share-fill, #reset-all-timeframes, #info-btn, #map-key-btn {
  margin-right: 5px; 
}

.sub-graph-container{
  position: relative;
}

.reset, .download{
  border: 3px solid #000000;
  height:40px;
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 10;
}

.download{
  right: 70px;
}

.info {
  height: 35px;
}

.popup-button-div{
  justify-content: center;
}

.reset-and-copy-link{
  height:40px
}

.popup-button{
  width: 170px;
  justify-content: center;
  height:40px;
  margin-top: 2px;
}

.marker-popup{
  font-size: 15px;
}

.graphs-container{
  position: relative;
  border-radius: 25px;
  width: 92%;
  border: 4px solid #000000;
  margin: 0 auto; 
  background-color: #6c757d;
}

.stats-container{
  margin: 0 auto;
  width: 92%;
  flex-wrap: wrap;
  justify-content: space-between;
}

.stats{
  border-radius: 25px;
  height: 105px;
  width: 100%;
  border: 4px solid #000000;
  margin: 0 auto;
}
.stat-block{
  width: calc(33.33% - 13px); /* Adjust the percentage and margin as needed */
  display: inline-block;
}

#map-key{
  position: absolute;
  top: 14px;
  right: 70px;
  z-index: 401;
  height: 37px;
}

#controls-popup, #map-key-popup{
  max-width: 70vw;
}

@media (max-width: 700px) {
  .stat-block {
    width: calc(100% - 16px);
  }
  #upload-stat, #latency-stat{
    width: calc(50% - 16px);
  }
}

.leaflet-attribution-flag{
  height: 0px;
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/css/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,UAAU;EACV,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,0BAA0B,EAAE,+CAA+C;EAC3E,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,WAAW;EACX,aAAa;AACf","sourcesContent":[".Dashboard {\n  text-align: center;\n  background-color:#FFFFFF;\n}\n\nh1 {\n  margin-top:0px;\n  margin-bottom:20px;\n  color: #343434;\n  font-size: 35px;\n}\n\np {\n  font-size: 16px;\n}\n\n.App-header, .App-body{\n  min-height: 100vh;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n.graphs, .leaflet-container{\n  border-radius: 25px;\n  width: 100%;\n  height: 350px;\n  border: 4px solid #000000;\n  margin: 0 auto;\n}\n\n.leaflet-container{\n  height:340px;\n}\n\n.map-container{\n  width: 92%;\n  position: relative;\n  margin: 0 auto;\n}\n\n#map-dark-theme-btn{\n  position: absolute;\n  top: 14px;\n  right: 16px;\n  z-index: 401;\n}\n\n#map-show-all-nodes-btn{\n  position: absolute;\n  top: 14px;\n  right: 65px;\n  z-index: 401;\n}\n\n#copy-link-btn{\n  position: absolute;\n  top: 60px;\n  right: 16px;\n  z-index: 401;\n}\n\n#scoll-to-top-btn{\n  position: fixed; \n  bottom: 20px; \n  right: 20px;  \n  display: flex; \n  justify-content: center; \n  height:55px;\n  width:55px;\n  border: 3px solid #000000;\n  z-index: 405;\n}\n\n#map-popup{\n  z-index: 402 !important;\n}\n\n.bi-share-fill, #reset-all-timeframes, #info-btn, #map-key-btn {\n  margin-right: 5px; \n}\n\n.sub-graph-container{\n  position: relative;\n}\n\n.reset, .download{\n  border: 3px solid #000000;\n  height:40px;\n  position: absolute;\n  right: 20px;\n  top: 20px;\n  z-index: 10;\n}\n\n.download{\n  right: 70px;\n}\n\n.info {\n  height: 35px;\n}\n\n.popup-button-div{\n  justify-content: center;\n}\n\n.reset-and-copy-link{\n  height:40px\n}\n\n.popup-button{\n  width: 170px;\n  justify-content: center;\n  height:40px;\n  margin-top: 2px;\n}\n\n.marker-popup{\n  font-size: 15px;\n}\n\n.graphs-container{\n  position: relative;\n  border-radius: 25px;\n  width: 92%;\n  border: 4px solid #000000;\n  margin: 0 auto; \n  background-color: #6c757d;\n}\n\n.stats-container{\n  margin: 0 auto;\n  width: 92%;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.stats{\n  border-radius: 25px;\n  height: 105px;\n  width: 100%;\n  border: 4px solid #000000;\n  margin: 0 auto;\n}\n.stat-block{\n  width: calc(33.33% - 13px); /* Adjust the percentage and margin as needed */\n  display: inline-block;\n}\n\n#map-key{\n  position: absolute;\n  top: 14px;\n  right: 70px;\n  z-index: 401;\n  height: 37px;\n}\n\n#controls-popup, #map-key-popup{\n  max-width: 70vw;\n}\n\n@media (max-width: 700px) {\n  .stat-block {\n    width: calc(100% - 16px);\n  }\n  #upload-stat, #latency-stat{\n    width: calc(50% - 16px);\n  }\n}\n\n.leaflet-attribution-flag{\n  height: 0px;\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
